<template>
  <div class="ee-card-attribute select">
    <r-text type="caption" style="margin-bottom: 8px;">
      {{ config.label }}
    </r-text>
    <div class="ee-card-attribute-content">
      <el-select
        v-if="values[config.values]"
        class="r-select"
        size="mini"
        v-model="feature[config.prop]"
      >
        <el-option
          v-for="item in values[config.values]"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  props: ["feature", "config"],
  data() {
    return {
      values: {}
    };
  },
  methods: {
    async getData() {
      try {
        const url = `objectInfo/${this.config.request}`;
        const { data } = await this.$store.dispatch("REQUEST", { url });
        this.$set(this.values, this.config.values, Object.values(data));
      } catch (error) {
        console.log(error);
      }
    }
  },
  created() {
    if (this.config.request) {
      this.getData();
    }
  }
};
</script>

<style lang="scss">
.ee-card-attribute.select {
  .ee-card-attribute-content {
    .el-select {
      width: 100%;
    }
  }
}
</style>
